module.exports = __webpack_public_path__ + "static/go-burguer-jogador-nfl-bg-92c68e1ee45b402b5baf39f5c7a4064b.jpg";